import React, { Component } from 'react'
import apiService from '../../services/ApiService'
import Select from 'react-select'

class EntityType extends Component {
    constructor() {
        super()
        this.state = {
            entityTypeList: "",
        }
        this.isComponentStillMounted = true
    }

    componentDidMount() {
        this.getEntyTypesList(this.props.type)
    }

    componentWillUnmount() {
        this.isComponentStillMounted = false
    }

    getEntyTypesList = (type) => {
        apiService.getEntyTypesList(type)
            .then(listData => {
                if (listData && this.isComponentStillMounted) {
                     this.setState({
                        entityTypeList: listData.data
                    })
                    
                }
            })
            .catch(err => {
                console.error("Error data: ", err)
            })
    }

    render() {
        let list = {}
        list = Object.keys(this.state.entityTypeList).map((value,index) => {
            
            return {
                label : this.state.entityTypeList[value],
                value : this.state.entityTypeList[value]
            }
        })
        list.sort((a,b) => a.label.localeCompare(b.label));

        return (
            <div>
                <Select
                value={this.props.selectedValue}
                placeholder="Select Type"
                options={list}                
                disabled={this.props.disabled}
                onChange={(e) => { (e) ? this.props.entityTypeChange(e,this.props.dataId) : this.props.entityTypeChange([],this.props.dataId)}}
                />
            </div>
        )
    }
}
export default EntityType


// WEBPACK FOOTER //
// ./src/common/DropDowns/EntityType.js